import { render, staticRenderFns } from "./AgTableIsActiveIcon.vue?vue&type=template&id=def37aac&scoped=true&"
import script from "./AgTableIsActiveIcon.vue?vue&type=script&lang=js&"
export * from "./AgTableIsActiveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def37aac",
  null
  
)

export default component.exports